const p = (url: string) => `https://images.weserv.nl/?url=${url.replace('https://', '')}&output=webp&q=80&n=-1`;

export const vehicles = [
  {
    id: 'lamborghini-huracan',
    brand: 'Lamborghini',
    model: 'Huracán Tecnica',
    category: 'Superdeportivo',
    pricePerDay: 112000,
    deposit: 200000,
    pricing: {
      '30min': 12000,
      '1h': 22000,
      '6h': 40320,
      '12h': 67200,
      '24h': 112000
    },
    images: [
      p('https://sunandspeed.com/wp-content/uploads/2025/04/PRINCIPAL-lamborghini-6-1.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/lamborghini-2-1.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/DSC07331-1.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/Copia-de-EFC432B1-1D36-4340-8AA6-B52F3944DA50-1.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/lamborghini-1-1.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/lamborghini-4-1.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/lamborghini-5-1.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/lamborghini-8-1.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/lamborghini-9-1.webp')
    ],
    description: 'Un símbolo de poder bruto y diseño más allá de la imaginación. Lamborghini transforma la carretera en tu escenario personal: audaz, ruidoso, inconfundible.',
    features: [
      'Motor V10 de 640 HP',
      '0-100 km/h en 3.2 segundos',
      'Velocidad máxima: 325 km/h',
      'Tracción trasera',
      'Interior de cuero premium Alcantara',
      'Sistema de infoentretenimiento avanzado',
      'Aerodinámica activa',
      'Frenos de carbono-cerámica'
    ],
    specifications: {
      passengers: 2,
      transmission: 'Automática LDF',
      fuel: 'Gasolina Premium',
      year: 2024
    }
  },
  {
    id: 'mclaren-750s',
    brand: 'McLaren',
    model: '750S',
    category: 'Superdeportivo',
    pricePerDay: 120000,
    deposit: 200000,
    pricing: {
      '30min': 12000,
      '1h': 22000,
      '6h': 43200,
      '12h': 72000,
      '24h': 120000
    },
    images: [
      p('https://sunandspeed.com/wp-content/uploads/2025/04/7.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/6.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/10.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/4.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/11.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/9.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/8.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/5.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/3.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/2.webp')
    ],
    description: 'Velocidad pura, envuelta en innovación. El ADN nacido de las carreras de McLaren se encuentra con un diseño futurista para ofrecer una experiencia única.',
    features: [
      'Motor V8 Twin-Turbo de 750 HP',
      '0-100 km/h en 2.8 segundos',
      'Velocidad máxima: 332 km/h',
      'Chasis de fibra de carbono MonoCell',
      'Puertas tipo mariposa',
      'Suspensión adaptativa Proactive',
      'Sistema de escape deportivo',
      'Aerodinámica activa'
    ],
    specifications: {
      passengers: 2,
      transmission: 'Automática SSG',
      fuel: 'Gasolina Premium',
      year: 2024
    }
  },
  {
    id: 'ferrari-roma',
    brand: 'Ferrari',
    model: 'Roma Spider',
    category: 'Deportivo de Lujo',
    pricePerDay: 104000,
    deposit: 180000,
    pricing: {
      '30min': 12000,
      '1h': 22000,
      '6h': 37440,
      '12h': 62400,
      '24h': 104000
    },
    images: [
      p('https://sunandspeed.com/wp-content/uploads/2025/04/IMG_3231.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/IMG_3233.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/Copia-de-A73E6B74-8779-477F-983C-EF557A809BC0.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/Copia-de-DC038BCB-A217-44CC-935C-AE7CB7CF32D2.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/Copia-de-F2CF68D4-A183-493E-9C3B-C7F68C480902.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/ferrari-roma.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/IMG_3226.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/IMG_3227.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/IMG_3228.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/IMG_3229.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/IMG_3230.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/IMG_3232.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/IMG_3234.webp')
    ],
    description: 'Desata la icónica ingeniería italiana con la potencia, precisión y belleza que acelera el pulso que solo Ferrari ofrece. Cada detalle está diseñado para la adrenalina y la elegancia.',
    features: [
      'Motor V8 Turbo de 620 HP',
      '0-100 km/h en 3.4 segundos',
      'Velocidad máxima: 320 km/h',
      'Techo retráctil',
      'Interior de cuero Frau',
      'Sistema de infoentretenimiento avanzado',
      'Control de tracción F1-Trac',
      'Frenos de carbono-cerámica'
    ],
    specifications: {
      passengers: 4,
      transmission: 'Automática DCT',
      fuel: 'Gasolina Premium',
      year: 2024
    }
  },
  {
    id: 'porsche-911',
    brand: 'Porsche',
    model: 'Targa 911',
    category: 'Deportivo',
    pricePerDay: 48000,
    deposit: 140000,
    pricing: {
      '30min': 12000,
      '1h': 22000,
      '6h': 17280,
      '12h': 28800,
      '24h': 48000
    },
    images: [
      p('https://sunandspeed.com/wp-content/uploads/2025/04/1.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/2-1.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/3-1.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/4-1.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/5-1.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/6-1.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/7-1.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/8-1.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/9-1.webp')
    ],
    description: 'Equilibrio, alma y deportividad atemporal. Porsche es para aquellos que anhelan rendimiento inteligente y manejo refinado.',
    features: [
      'Motor Boxer de 6 cilindros 385 HP',
      '0-100 km/h en 4.2 segundos',
      'Velocidad máxima: 293 km/h',
      'Techo Targa removible',
      'Sistema Porsche Active Suspension',
      'Interior deportivo premium',
      'Volante deportivo multifunción',
      'Asientos deportivos adaptativos'
    ],
    specifications: {
      passengers: 4,
      transmission: 'PDK Automática',
      fuel: 'Gasolina Premium',
      year: 2024
    }
  },
  {
    id: 'bmw-m440i',
    brand: 'BMW',
    model: 'M440i',
    category: 'Deportivo Premium',
    pricePerDay: 26000,
    deposit: 50000,
    pricing: {
      '1h': 15600,
      '6h': 26000
    },
    images: [
      p('https://sunandspeed.com/wp-content/uploads/2025/04/5-2.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/3-2.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/4-2.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/6-2.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/7-2.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/8-2.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/2-2.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/1-1.webp')
    ],
    description: 'Deportividad alemana refinada. El BMW M440i combina elegancia, tecnología y rendimiento en un paquete sofisticado.',
    features: [
      'Motor de 6 cilindros en línea TwinPower Turbo de 382 HP',
      '0-100 km/h en 4.5 segundos',
      'Tracción integral xDrive',
      'Suspensión deportiva adaptativa',
      'Interior de cuero Vernasca',
      'Sistema iDrive 7.0',
      'Asientos deportivos con calefacción',
      'Iluminación ambiental'
    ],
    specifications: {
      passengers: 4,
      transmission: 'Automática 8 velocidades',
      fuel: 'Gasolina Premium',
      year: 2024
    }
  },
  {
    id: 'mercedes-g-wagon',
    brand: 'Mercedes-Benz',
    model: 'AMG G63',
    category: 'SUV de Lujo',
    pricePerDay: 48000,
    deposit: 140000,
    pricing: {
      '1h': 17280,
      '6h': 28800,
      '12h': 48000
    },
    images: [
      p('https://sunandspeed.com/wp-content/uploads/2025/04/4-3.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/1-2.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/2-3.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/3-3.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/5-3.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/6-3.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/7-3.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/04/8-3.webp')
    ],
    description: 'Agresivo, poderoso e innegablemente prestigioso. El G-Wagon AMG combina herencia militar con lujo incomparable.',
    features: [
      'Motor V8 Biturbo de 585 HP',
      '0-100 km/h en 4.5 segundos',
      'Tracción 4MATIC permanente',
      'Tres bloqueos de diferencial',
      'Interior de cuero Nappa',
      'Sistema Burmester 3D',
      'Suspensión independiente',
      'Paquete AMG Night'
    ],
    specifications: {
      passengers: 5,
      transmission: 'Automática 9G-TRONIC',
      fuel: 'Gasolina Premium',
      year: 2024
    }
  },
  {
    id: 'range-rover',
    brand: 'Land Rover',
    model: 'Range Rover Autobiography',
    category: 'SUV de Lujo',
    pricePerDay: 34000,
    deposit: 100000,
    pricing: {
      '1h': 20400,
      '6h': 34000
    },
    images: [
      p('https://sunandspeed.com/wp-content/uploads/2025/05/11.webp')
    ],
    description: 'Donde la comodidad se encuentra con la confianza. Range Rover te ofrece sofisticación con capacidad todoterreno: el SUV del caballero.',
    features: [
      'Motor V8 Supercharged de 525 HP',
      'Sistema Terrain Response 2',
      'Suspensión neumática adaptativa',
      'Interior de lujo británico',
      'Asientos con masaje y ventilación',
      'Sistema Meridian Signature',
      'Techo panorámico',
      'Capacidad de vadeo de 90 cm'
    ],
    specifications: {
      passengers: 5,
      transmission: 'Automática 8 velocidades',
      fuel: 'Gasolina Premium',
      year: 2024
    }
  },
  {
    id: 'lamborghini-urus',
    brand: 'Lamborghini',
    model: 'Urus S (Green)',
    category: 'SUV Superdeportivo',
    pricePerDay: 96000,
    deposit: 180000,
    pricing: {
      '1h': 34560,
      '6h': 57600,
      '12h': 96000
    },
    images: [
      p('https://sunandspeed.com/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-27-at-7.50.33-PM-3.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-27-at-7.50.33-PM-4.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-27-at-7.50.33-PM-5.webp')
    ],
    description: 'El primer Super SUV del mundo. Combina el ADN de Lamborghini con la comodidad de un SUV. Motor V8 biturbo de 657 hp. Lujoso, espacioso y brutalmente rápido: 0 a 100 km/h en solo 3.5 segundos.',
    features: [
      'Motor V8 Twin-Turbo de 657 HP',
      '0-100 km/h en 3.5 segundos',
      'Velocidad máxima: 305 km/h',
      'Tracción integral permanente',
      'Modo ANIMA con 6 modos de conducción',
      'Suspensión neumática adaptativa',
      'Interior de cuero y Alcantara',
      'Sistema de escape deportivo'
    ],
    specifications: {
      passengers: 5,
      transmission: 'Automática 8 velocidades',
      fuel: 'Gasolina Premium',
      year: 2024
    }
  },
  {
    id: 'cadillac-escalade-1',
    brand: 'Cadillac',
    model: 'Escalade CR',
    category: 'SUV de Lujo',
    pricePerDay: 34000,
    deposit: 100000,
    pricing: {
      '1h': 20400,
      '6h': 34000
    },
    images: [
      p('https://sunandspeed.com/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-27-at-7.50.33-PM-10.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-27-at-7.50.33-PM-11.webp')
    ],
    description: 'SUV de lujo americano icónico. Diseño audaz, enorme espacio interior, sistema de sonido premium y un potente motor V8. Un vehículo de declaración para viajes grupales y eventos.',
    features: [
      'Motor V8 potente',
      'Espacio interior masivo',
      'Sistema de sonido premium',
      'Diseño audaz americano',
      'Ideal para grupos',
      'Tecnología avanzada',
      'Asientos de lujo',
      'Capacidad para eventos'
    ],
    specifications: {
      passengers: 7,
      transmission: 'Automática',
      fuel: 'Gasolina Premium',
      year: 2024
    }
  },
  {
    id: 'cadillac-escalade-2',
    brand: 'Cadillac',
    model: 'Escalade CR',
    category: 'SUV de Lujo',
    pricePerDay: 34000,
    deposit: 100000,
    pricing: {
      '1h': 20400,
      '6h': 34000
    },
    images: [
      p('https://sunandspeed.com/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-27-at-7.50.33-PM-11.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-27-at-7.50.33-PM-10.webp')
    ],
    description: 'SUV de lujo americano icónico. Diseño audaz, enorme espacio interior, sistema de sonido premium y un potente motor V8. Un vehículo de declaración para viajes grupales y eventos.',
    features: [
      'Motor V8 potente',
      'Espacio interior masivo',
      'Sistema de sonido premium',
      'Diseño audaz americano',
      'Ideal para grupos',
      'Tecnología avanzada',
      'Asientos de lujo',
      'Capacidad para eventos'
    ],
    specifications: {
      passengers: 7,
      transmission: 'Automática',
      fuel: 'Gasolina Premium',
      year: 2024
    }
  },
  {
    id: 'porsche-macan',
    brand: 'Porsche',
    model: 'Macan',
    category: 'SUV Deportivo',
    pricePerDay: 30000,
    deposit: 80000,
    pricing: {
      '1h': 18000,
      '6h': 30000
    },
    images: [
      p('https://sunandspeed.com/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-27-at-7.50.34-PM.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-27-at-7.50.34-PM-1.webp'),
      p('https://sunandspeed.com/wp-content/uploads/2025/05/WhatsApp-Image-2025-05-27-at-7.50.33-PM-12.webp')
    ],
    description: 'SUV de lujo compacto con ADN de auto deportivo. Ágil, rápido y refinado. Ideal para cruceros urbanos o escapadas de fin de semana. Entrada asequible al rendimiento Porsche.',
    features: [
      'Motor turbo potente',
      'Manejo deportivo ágil',
      'Interior premium',
      'Tecnología Porsche',
      'Compacto y versátil',
      'Rendimiento refinado',
      'Ideal para ciudad',
      'Escapadas de fin de semana'
    ],
    specifications: {
      passengers: 5,
      transmission: 'PDK Automática',
      fuel: 'Gasolina Premium',
      year: 2024
    }
  }
];

export const featuredVehicles = vehicles.slice(0, 6);
